import { SearchType } from '@/types/most-search-type';

export const defaultTerms = {
  [SearchType.PRESENTIAL_CONSULTATION]: 'consulta',
  [SearchType.ONLINE_CONSULTATION]: 'teleconsulta',
  [SearchType.LABORATORIAL_EXAM]: 'exame',
  [SearchType.IMAGE_EXAM]: 'exame de imagem',
};

export type MostSearchedType = keyof typeof defaultTerms;
